<template>
  <el-container class="indexhome">
    <el-header>
      <p>现有课时</p>
      <span>{{balance}}</span>
    </el-header>
    <el-main>
      <div class="payItem" v-for="(item,i) in quantityData" :key='i'>
        <div class="payTitle">
          <p>{{item.title}}</p>
          <span>${{item.price}} USD</span>
        </div>
        <div class="creditName">
          <div>
            <div class="money">
              <span></span>
              <p>{{item.quantity}}课时</p>
            </div>
            <div class="money">
              <span class="freeSpan"></span>
              <p class="freeeP">{{item.extra_quantity}}个额外免费课时</p>
            </div>
          </div>
          <button @click="toPay(item)">支付</button>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
export default {
  name: 'payList',
  data () {
    return {
      quantityData: [],
      balance: '',
      handleResultNew: function (result) {
        if (result.error) {
          alert('failed')
        }
      }
    }
  },
  created () {
    setStore(keys.token,this.$route.query.token)
    this.getQuantity()
  },
  mounted () {
    // console.log(navigator.userAgent)
    // let phone = navigator.userAgent// 设备机型的相关信息
    // phone = phone.substring(phone.indexOf('(') + 1, phone.indexOf(';'))// 处理信息，输出iphone
    // console.log(phone)
    // var u = navigator.userAgent
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // console.log(isAndroid)
    // console.log(isiOS)
    // this.shareForm.user_agent = isiOS ? 'iphone' : (isAndroid ? 'android' : '')
  },
  methods: {
    getQuantity () {
      this.$http.get('/api/recharge/quantityApp').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.balance = res.data.data.balance
          this.quantityData = res.data.data.list
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    createCheckoutSession (id) {
      let that = this
      return new Promise((resolve, reject) => {
        that.$http.post('/api/testStripe', {
          lessons_goods_id: id,
          type: 'mobile',
          token: getStore(keys.token)
        })
          .then(res => {
            console.log(res)

            resolve(res.data.sessionId)
            return res.data.sessionId
          })
      })
    },
    toPay (item) {
      console.log(item);
      window.open(`https://management.twinkletalk.com.cn/goods/paymenthly?id=${item.id}&type=credit&token=${this.$route.query.token}`)

      return;
      var that = this
      if (!item.id) {
        this.$message({
          message: this.$t('recharge.selectPackage'),
          type: 'warning'
        })
        return false
      }

      this.utils.setCookies({setPayData: JSON.stringify(item)})
      // var stripe = Stripe('pk_live_51H2iOSLvUcRqAd8piK4KqTRgmvlxgG1S7pMoER8Ike9oBpfOtVzEjzQWiErwW4kbxDOiQ9xkKETm60RXQcEXx108007VlSNnrR')
      // var stripe = Stripe('pk_test_51H2iOSLvUcRqAd8paHZmX26Fkazd889p8f7lw8kBXdsDDsosvXZf1GQNFdTrx2EcQxlHMQklcjL7ie3WfnTgjAgj00Y1lnu2NJ')
      var stripe = Stripe('pk_test_51RGG6ZIBr6phPyq4PEtjh44PIoscHn33jEidwGoBmGN741r71daymBkbRg9Wj886fSSjdGDDk9wQiHpfkoAmbnGa00jow9ZZwe')
      this.createCheckoutSession(item.id).then(data => {stripe.redirectToCheckout({
            sessionId: data
          })
          .then(this.handleResultNew)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 100vw;
    margin: 0 auto;
  }
  #intercom-frame{
    display: none;
  }
  .el-header{
      width: 100vw;
      height:97px!important;
      padding: 20px 20px 0;
      font-family: Sofia Pro-Regular;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      background: #fff;
      span{
        font-size: 38px;
      }
  }
  .el-main{
    overflow-y:scroll;
    padding:0 20px 20px;
    .payItem{
      width: 100%;
      // height: 139px;
      background: #FFFFFF;
      border: 1px solid rgba(165, 165, 165, 0.3);
      box-sizing: border-box;
      border-radius: 12px;
      margin-top: 20px;
        padding: 0 22px;
      .payTitle{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding:10px 0;
        border-bottom: 1px solid rgba(165, 165, 165, 0.5);
        p{
          font-size: 16px;
          color: #424347;
        }
        span{
          font-size: 24px;
          color: #424347;
          font-weight: 800;
        }
      }
      .creditName{
        display: flex;
        justify-content: space-between;
        align-items:flex-end;
        margin:10px 0 20px;
        .money{
          display: flex;
          justify-content: start;
          align-items: center;
          margin-bottom:5px;
          span{
            width:8px;
            height:8px;
            display: inline-block;
            border-radius: 50%;
            background: #E0E0E0;
            margin-right:10px;
          }
          p{
            font-size: 18px;
            color: #424347;
          }
          .freeSpan{
            background: #F2C94C;
          }
          .freeeP{
            color: #FF6440;
            font-family: Sofia Pro-Bold;
            span{
              width: auto;
              height:auto;
              background: none;
              border-radius:inherit;
              display: inline-block;
              font-family: Sofia Pro-Bold-Italic;
            }
          }
        }
        button{
          padding:5px 15px;
          border:none;
          background: #FF6440;
          border-radius: 5px;
          font-family: Sofia Pro-Bold;
          font-size: 18px;
          color:#fff;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/payList.vue